module.exports = __webpack_public_path__ + "static/img/meeting_item1.548d862.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/meeting_item1.png
// module id = lfmm
// module chunks = 2